import { createStore } from 'vuex';
import axios from 'axios';
import router from '../router';
 
const store = createStore({
    state: {
        // 状态
        isLoggedIn: false,  
        userName: ''
    },
    mutations: {
        // 修改状态的方法
        setLoggedIn(state, payload) {
            state.isLoggedIn = payload.isLoggedIn;
            if (payload.userName) {
                state.userName = payload.userName;
            }
        },
        logout(state) {
            state.isLoggedIn = false;
            state.userName = '';
        }
    },
    actions: {
        // 异步操作
        async login({ commit }, { username, password }) {
            try {
                const loginResponse = await axios.post('/api/login', { username, password }, {timeout: 30000}); //这里timeout为设置的请求超时时间
                const token = loginResponse.data.token;
                const expiresIn = loginResponse.data.expiresIn;
                
                // 存储 token 到 localStorage 或其他状态管理库
                localStorage.setItem('token', token);
                
                // 存储 token 过期时间
                const now = Date.now();
                const expirationTime = now + expiresIn * 1000;  // 转换为毫秒
                localStorage.setItem('tokenExpiration', expirationTime.toString());

                // 存储登录用户名
                localStorage.setItem('userName', username);
                
                // 成功后提交 mutation 来更新登录状态和用户名
                commit('setLoggedIn', { isLoggedIn: true, userName: username });

                // 检查是否有保存的路由，并重定向用户
                const redirectRoute = sessionStorage.getItem('redirectRoute');
                console.log('redirectRoute:', redirectRoute);
                if (redirectRoute) {
                    router.push(redirectRoute).catch(err => {
                        console.log(err);  // 如果 push 方法出错，打印出错误信息
                    });
                    sessionStorage.removeItem('redirectRoute');
                } else {
                    router.push('/user').catch(err => {
                        console.log(err);  // 如果 push 方法出错，打印出错误信息
                    });
                }
            } catch (error) {
                console.error(error);
                if (error.response) {
                    // 服务器返回了一个错误响应
                    throw new Error(error.response.data.message);
                } else if (error.request) {
                    // 请求已经发送，但没有收到响应（通常发生在网络问题或服务器未响应）
                    throw new Error('网络错误');
                } else {
                    // 发送请求时出现了一些问题
                    throw new Error(error.message);
                }
            }
        },
        async logout({ commit }) {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    await axios.post('/api/logout', null, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    // 清除本地存储的 token
                    localStorage.removeItem('token');
                    // 成功后提交 mutation 来更新登录状态和用户名
                    commit('logout');

                    // 如果当前路由是 '/user'，则跳转到登录页
                    if (router.currentRoute.value.path === '/user') {
                        router.push('/login');
                    }
                }
            } catch (error) {
                console.error(error);
                throw new Error('An error occurred while logging out.');
            }
        }
    }
});
 
export default store;